/* eslint-disable @typescript-eslint/no-use-before-define */
import { useMemo } from 'react';
import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';

import { UseCaseGridItem, type UseCaseItem } from './UseCaseGridItem';

const Items = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    grid-template-columns: 1fr;
  }
`;

interface UseCasePreviewGridProps {
  maxItems?: number;
}

interface UseCaseData {
  allContentfulUseCase: {
    nodes: UseCaseItem[];
  };
}

export const UseCasePreviewGrid: React.ComponentType<UseCasePreviewGridProps> =
  React.memo(({ maxItems }) => {
    const data: UseCaseData = useStaticQuery(pageQuery);
    const useCases = data.allContentfulUseCase.nodes;

    const useCasesToShow = useMemo(() => {
      if (useCases === null || useCases === undefined) {
        return [];
      }
      return useCases
        .filter(
          (useCase: UseCaseItem) =>
            useCase.category &&
            useCase.category.title === 'Exploratory Analysis'
        )
        .slice(0, maxItems);
    }, [maxItems, useCases]);

    return (
      <Items>
        {useCasesToShow.map((item: UseCaseItem, index: number) => (
          <UseCaseGridItem key={index} useCase={item} />
        ))}
      </Items>
    );
  });

const pageQuery = graphql`
  query {
    allContentfulUseCase {
      nodes {
        ...BlockContentfulUseCase
      }
    }
  }
`;
